;(function ($) {
    'use strict';
    $(document).ready(function () {

        $(document).on('click', '.remove-cart-item', function (e) {
            e.preventDefault();

            if (!confirm('Are you sure you want to remove this item?')) {
                return;
            }

            const item = this.dataset.item;

            $.post({
                url: '/api/cart/remove-item',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    {
                        item: item,
                    }
                ),

                success: (response) => {
                    updateTransactionItemTable(response.items, response.costs, this, 'There are no items in your cart');
                },

                error: e => {
                    handleError(e);
                }
            });
        });


        $(document).on('click', '.remove-quote-item', function (e) {
            e.preventDefault();

            if (!confirm('Are you sure you want to remove this item?')) {
                return;
            }

            const item = this.dataset.item;
            const transactionCode = this.dataset.transaction;

            $.post({
                url: '/api/cart/remove-quote-item',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    {
                        item: item,
                        transaction_code: transactionCode,
                    }
                ),

                success: (response) => {
                    if (response.transactionItems.length === 0) {
                        return window.location = '/checkout/quotes';
                    }

                    updateTransactionItemTable(response.transactionItems, response.costs, this);
                },

                error: e => {
                    handleError(e);
                }
            });
        });


        $(document).on('click', '.remove-order-item', function (e) {
            e.preventDefault();

            if (!confirm('Are you sure you want to remove this item?')) {
                return;
            }

            const item = this.dataset.item;
            const transactionCode = this.dataset.transaction;

            $.post({
                url: '/api/orders/remove-item',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    {
                        item: item,
                        transaction_code: transactionCode,
                    }
                ),

                success: (response) => {
                    if (response.message) {
                        // Handle success.
                    }
                },

                error: e => {
                    handleError(e);
                }
            });
        });


        $(document).on('click', '.same-as-billing', function () {
            if (this.checked) {
                $.post({
                    url: '/api/orders/set-same-as-billing',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(
                        {
                            transactionCode: this.dataset.transaction,
                            billingId: this.dataset.billingId,
                        }
                    ),

                    success: (response) => {

                    },
                    error: e => {
                        console.log(e);
                    }
                });
            }
        });


        $(document).on('click', '.set-shipping-method', function (e) {
            e.preventDefault();

            setShipping(this);
        });

        $(document).on('click', '.shipping-method-button', function () {
            $('.shipping-method-button').removeClass('selected');
            $(this).addClass('selected');
        });

        let timer;
        const timerInterval = 1000;
        $(document).on('input', '.shipping-option-value', function (e) {
            if (this.type === 'text') {
                return;
            }

            clearTimeout(timer);
            timer = setTimeout(() => setShipping(this), timerInterval);
        })

        function setShipping(element) {
            const shippingId = element.dataset.id;
            const transactionCode = element.dataset.transaction;
            const priorityId = element.dataset.priority;
            const optionId = element.dataset.option;

            // if an input with auto-select is selected, disable clicking on options
            const autoSelectButtons = $('.shipping-method-priority.selected[data-auto-select]');
            const prioritySelected = $('.shipping-method-priority.selected').data('auto-select');
            const optionSelected = $('.shipping-method-option.selected').data('title');
            const optionsSelected = optionSelected === prioritySelected;
            if (autoSelectButtons.length && optionsSelected.length) {
                return;
            }

            // if the clicked item is an option. the priority is set to an auto-select.
            if ($(element).hasClass('shipping-method-option') && prioritySelected && prioritySelected !== element.dataset.title) {
                return;
            }

            let optionValue;
            if (element.dataset.value) {
                optionValue = element.value;
            }

            $.post({
                url: '/api/orders/set-shipping',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    {
                        shippingId,
                        transactionCode,
                        priorityId,
                        optionId,
                        optionValue,
                    }
                ),

                success: (response) => {
                    //for pickup and TBD methods
                    if (response.selectedMethod === '1') {
                        $('.method-1').addClass('selected');
                    } else {
                        $('.method-1').removeClass('selected');
                    }

                    if(response.selectedMethod === '5'){
                        $('.method-5').addClass('selected');
                    } else {
                        $('.method-5').removeClass('selected');
                    }

                    if (response.priorities.length) {
                        $('.shipping-priority').addClass('shown');
                    } else {
                        $('.shipping-priority').removeClass('shown');
                    }

                    let priorities = '';
                    for (const priority of response.priorities) {
                        let autoSelected = '';
                        if (priority.shipping_method_priority_is_restricted === '1') {
                            autoSelected = 'data-auto-select="Prepaid and Add"';
                        }

                        priorities += `<div 
                                            class="shipping-label input-label shipping-method-priority set-shipping-method ${priority.shipping_method_priority_id === response.selectedPriority ? 'selected' : ''}"
                                            data-transaction="${response.transaction}"
                                            data-id="${response.selectedMethod}"
                                            data-option="${response.selectedOption || ''}"
                                            data-priority="${priority.shipping_method_priority_id}"
                                            ${autoSelected}
                                    >
                                <div class="label-text">
                                    <button>${priority.shipping_method_priority_title}</button>
                                </div>
                                <div class="label-shadow">
                                </div>
                            </div>`;
                    }

                    $('.shipping-priority .input-group').html(priorities);

                    if (response.options.length) {
                        $('.shipping-billing-options').addClass('shown');
                    } else {
                        $('.shipping-billing-options').removeClass('shown');
                    }

                    let options = '';
                    for (const option of response.options) {
                        options += `<div class="shipping-label input-label shipping-method-option set-shipping-method ${option.shipping_method_option_id === response.selectedOption ? 'selected' : ''}"
                                        data-transaction="${response.transaction}"
                                        data-id="${response.selectedMethod}"
                                        data-option="${option.shipping_method_option_id}"
                                        data-priority="${response.selectedPriority || ''}"
                                        data-title="${option.shipping_method_option_title}"
                                >
                                <div class="label-text">
                                    <button>${option.shipping_method_option_title}</button>
                                </div>
                                <div class="label-shadow">
                                </div>
                            </div>`;

                        if (option.shipping_method_option_field_type === 'text') {
                            let elementClass = 'shipping-label input-label';

                            if ($(element).hasClass('shipping-method-option')) {
                                if (element.dataset.title !== 'Collect Option') {
                                    elementClass += ' hidden';
                                }
                            } else if ($(element).hasClass('shipping-method-button')) {
                                elementClass += ' hidden';
                            } else if ($(element).hasClass('shipping-method-priority')) {
                                if (!$('.shipping-method-option.selected[data-title="Collect Option"]').length) {
                                    elementClass += ' hidden';
                                }
                            }

                            options += `<div class="${elementClass}"
                                            data-toggle="${option.shipping_method_option_title}">
                                <div class="label-text">
                                    <input 
                                        class="shipping-option-value" 
                                        type="text"
                                        data-value="true"
                                        data-transaction="${response.transaction}"
                                        data-id="${response.selectedMethod}"
                                        data-option="${response.selectedOption || ''}"
                                        data-priority="${response.selectedPriority || ''}"
                                        value="${response.optionValue || response.account || ''}"
                                        placeholder="${response.selectedMethodTitle} Account No:"
                                        >
                                </div>
                                <div class="label-shadow">
                                </div>
                            </div>`;
                        }
                        console.log(option);
                    }

                    $('.shipping-billing-options .input-group').html(options);

                    $('.shipping-label:not(.selected):not(.method-' + response.selectedMethod + ') .label-text').css('background', '#FFF');

                    $('.shipping-label.selected .label-text').css('background', '#c1c5cc');
                    $(element).find('.label-text').css('background', '#c1c5cc');
                },

                error: e => {
                    handleError(e);
                }
            });
        }

        selectDefaultOption();

        function selectDefaultOption() {
            const autoSelectChecker = setInterval(() => {
                const autoSelect = $('.set-shipping-method.selected[data-auto-select]').data('auto-select');

                if (autoSelect) {
                    const selectElement = $(`.set-shipping-method[data-title="${autoSelect}"]`)

                    selectElement.click();
                    clearTimeout(autoSelectChecker);
                }
            }, 400);
        }

        $(document).on('click', '.shipping-method-priority[data-auto-select]', selectDefaultOption);


        $(document).on('click', '#proceed_to_payment', function (e) {
            e.preventDefault();
            if (
                (!$('.shipping-priority .selected').length
                || !$('.shipping-billing-options .selected').length)
                && (!$('.method-1.selected').length && !$('.method-5.selected').length)
            ) {
                e.preventDefault();
                return alert('Please select shipping options before proceeding.');
            }

            console.log('hit', e);
            const pickup = document.querySelector('.shipping-method-button.selected[data-method="Pick-Up (Call When Ready)"]');
            let accountValue;

            if (!$('.method-1.selected').length && !$('.method-5.selected').length) {
                const selectedOption = document.querySelector('.shipping-billing-options .shipping-label.selected').dataset.option;

                if (selectedOption === '1') {
                    accountValue = document.querySelector('.shipping-option-value').value;
                }

                // if ups or fedex with collect option selected, require account number.
                const selectedMethod = $('.shipping-method-button.selected[data-method]').data('method');

                const autoSelect = $('.set-shipping-method.selected[data-auto-select]').data('auto-select');
                const selectedText = $('.shipping-billing-options .shipping-label.selected > div > button').html();

                if (autoSelect !== 'Prepaid and Add' && selectedText === 'Collect Option' && selectedMethod === 'UPS' || selectedMethod === 'Fed Ex') {
                    console.log(autoSelect, selectedMethod, accountValue);
                    if (!accountValue) {
                        return alert('Please enter your ' + selectedMethod + ' account number');
                    }
                }
            }

            const transactionCode = document.querySelector('.set-shipping-method').dataset.transaction;

            $.post({
                url: '/api/orders/verify-transaction-addresses',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    {
                        transactionCode,
                        accountValue,
                    }
                ),
                success: () => {
                    window.location = window.location.href + '/review';
                },
                error: err => {
                    return alert(JSON.parse(err.responseText).message);
                }
            });
        });


        function updateTransactionItemTable(items, costs, removed, emptyText = 'No Items') {
            if (items.length === 0) {
                $('.cart-cell').html('');
                $('.cart-cell').first().text(emptyText);
                $('.cart-buttons').html('');
            } else {
                console.log('remove', removed.dataset.item);
                $('.cart-entry[data-item=' + removed.dataset.item + ']').remove();
                // remove by data-item-id
            }

            $('#sub-total-cost').text(costs.subTotal);
            $('#discount-value').text(costs.discount);
            $('#promo-value').text(costs.promo);
            $('#gross-total-cost').text(costs.total);
        }

        let editing = false;
        $(document).on('click', '.cart-entry-details .edit-button', function(e) {
            const item = this.dataset.item;
            const container = this.parentElement;

            if (editing === false) {
                const electrodeValue = $(container).find('.electrode .value').first().text().trim();
                $(container).find('.electrode .value').html('<input type="text" value="' + electrodeValue + '" name="electrode" />')

                const burnValue = $(container).find('.burn .value').first().text().trim();
                $(container).find('.burn .value').html('<input type="text" value="' + burnValue + '" name="burn" />');

                const jobValue = $(container).find('.job .value').first().text().trim();
                $(container).find('.job .value').html('<input type="text" value="' + jobValue + '" name="job" />')

                $(container).find('.edit-button').text('Save');

                editing = true;
            } else {
                const electrode = container.querySelector('.electrode input').value;
                const burn = container.querySelector('.burn input').value;
                const job = container.querySelector('.job input').value;

                $.post({
                    url: '/api/cart/update-item-details',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(
                        {
                            item,
                            electrode,
                            burn,
                            job
                        }
                    ),

                    success: (response) => {
                        $(container).find('.electrode .value').html(response.electrode);
                        $(container).find('.burn .value').html(response.burn);
                        $(container).find('.job .value').html(response.job);

                        $(container).find('.edit-button').text('Edit');

                        editing = false;
                    },

                    error: e => {
                        handleError(e);
                    }
                });
            }
        });


        $(".cart-page .add-discount-button").click(function(e) {
            const item = this.dataset.item;

            $.post({
                url: '/api/cart/apply-discount',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    {
                        discount_code: $('.discount-input').val(),
                    }
                ),
                success: (response) => {
                    console.log(response);
                    if (response.error) {
                        $('.discount-error').text(response.error);
                    } else {
                        $(this).html("Discount " + response.promo?.discount_code_code + " Applied");
                        $(".discount-input").hide();
                        $('#promo-value').text(response.promo?.discount_code_code);
                        $("#discount-value").text(response.discount);
                        $("#gross-total-cost").text('$' + response.total);
                    }
                },

                error: e => {
                    alert('Invalid discount code');
                }
            });
        });


        $(".quote-page .add-discount-button").click(function(e) {
            const transaction = this.dataset.transaction;

            $.post({
                url: '/api/cart/apply-quote-discount',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    {
                        transaction,
                        discount_code: $('.discount-input').val(),
                    }
                ),
                success: (response) => {
                    console.log(response);
                    if (response.error) {
                        $('.discount-error').text(response.error);
                    } else {
                        $(this).html("Discount " + response.promo + " Applied");
                        $(".discount-input").hide();
                        $('#promo-value').text(response.promo);
                        $("#discount-value").text('$' + response.discount);
                        $("#gross-total-cost").text('$' + response.total);
                    }
                },

                error: e => {
                    alert('Invalid discount code');
                }
            });
        });


        $(".review-payment-section .add-discount-button").click(function(e) {
            const transaction = this.dataset.transaction;

            $.post({
                url: '/api/cart/apply-quote-discount',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    {
                        transaction,
                        discount_code: $('.discount-input').val(),
                    }
                ),
                success: (response) => {
                    console.log(response);
                    if (response.error) {
                        $('.discount-error').text(response.error);
                    } else {
                        $(this).html("Discount " + response.promo + " Applied");
                        $(".discount-input").hide();
                        $('#promo-value').text(response.promo);
                        $("#discount-value").text('$' + response.discount);
                        $("#gross-total-cost").text('$' + response.total);
                    }
                },

                error: e => {
                    alert('Invalid discount code');
                }
            });
        });


        $('.email-group button').on('click', function (e) {
            e.preventDefault();
            if (this.dataset.value === 'yes') {
                $('.email-group button[data-value="no"]').removeClass('selected');
                $('.email-group button[data-value="yes"]').addClass('selected');
            } else {
                $('.email-group button[data-value="yes"]').removeClass('selected');
                $('.email-group button[data-value="no"]').addClass('selected');
            }

            $('#email_receipt_input').val(this.dataset.value);
        });
        
        $('.email-checkbox-container input').on('change', function (e) {
            if (e.target.checked) {
                console.log('check');
                $('.email-input-container').css('display', 'flex');
            } else {
                $('.email-input-container').css('display', 'none');
            }
        });

        $(document).on('change', '#sales_message_type', function () {
            $('.sales-message-value').css('display', 'none');
            $('.sales-message-' + this.value).css('display', 'block');
        });

        $(document).on('click', '#place_order_button', function (e) {
            e.preventDefault();

            const purchaseOrderSelected = document.querySelector('.purchase-info-type.selected');

            const formId = purchaseOrderSelected.classList.contains('purchase-order') ? '#purchase_order_form' : '#purchase_form';
            
            let formAction;
            if (formId === '#purchase_order_form') {
                formAction = '/api/orders/place-purchase-order';
            } else {
                formAction = '/api/orders/place-order';
            }

            const form = $(formId)[0];
            if (!form.checkValidity()) {
                form.reportValidity();
                
                return;
            }

            const formData = new FormData(form);
            
            const submitButton = document.querySelector('#place_order_button');

            submitButton.disabled = true;
            
            console.log(formData);

            $.post({
                url: formAction,
                data: formData,
                type: 'POST',
                processData: false,
                contentType: false,
                success: (response) => {
                    submitButton.disabled = false;
                    if (response.message) {
                        // Handle success.
                        window.location = '/checkout/' + response.transaction + '/complete';
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });

        $('#place_quote_button').on('click', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#place_quote_button');

            submitButton.disabled = true;

            const formData = new FormData($('#quote_form')[0]);

            $.post({
                url: '/api/orders/place-quote',
                data: formData,
                type: 'POST',
                processData: false,
                contentType: false,
                success: (response) => {
                    submitButton.disabled = false;
                    if (response.message) {
                        // Handle success.
                        window.location = '/quote/' + response.transaction + '/complete';
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });
        
        $('#add_attachment_1').on('click', function () {
            $('#attachment_group_2').css('display', 'flex');
        });
        $('#add_attachment_2').on('click', function () {
            $('#attachment_group_3').css('display', 'flex');
        });
        $('#add_attachment_3').on('click', function () {
            $('#attachment_group_4').css('display', 'flex');
        });
        $('#add_attachment_4').on('click', function () {
            $('#attachment_group_5').css('display', 'flex');
        });
        $('#add_attachment_5').on('click', function () {
            $('#attachment_group_6').css('display', 'flex');
        });
        $('#add_attachment_6').on('click', function () {
            $('#attachment_group_7').css('display', 'flex');
        });


        $('.cart-checkout-button').on('click', function () {
            const submitButton = this;
            submitButton.disabled = true;

            $.post({
                url: '/api/cart/checkout',
                dataType: 'json',
                contentType: 'application/json',
                data: '',
                success: (response) => {
                    submitButton.disabled = false;
                    if (response.message) {
                        window.location = '/checkout/' + response.transactionCode;
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });

        $('.cart-hover-container .cart-hover-close').on('click', function () {
            $('.cart-hover-container').addClass('hidden');
        });

        let cartHoverTimout = null;
        $('.cart-button-container').on('mouseenter', function () {
            cartHoverTimout = setTimeout(function () {
                $('.cart-hover-container').removeClass('hidden');
            }, 1000);
        });

        $('.cart-button-container').on('mouseout', () => clearTimeout(cartHoverTimout));

        $(document).on('click', '.cart-hover-container .remove-item', function (e) {
            e.preventDefault();

            if (!confirm('Are you sure you want to remove this item?')) {
                return;
            }

            const item = this.dataset.item;

            $.post({
                url: '/api/cart/remove-item',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    {
                        item: item,
                    }
                ),

                success: (response) => {
                    window.location.reload();
                },

                error: e => {
                    handleError(e);
                }
            });
        });
    });
})(jQuery, window, document);
